"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitterCard = void 0;
var TwitterCard;
(function (TwitterCard) {
    TwitterCard["Summary"] = "summary";
    TwitterCard["SummaryLargeImage"] = "summary_large_image";
    TwitterCard["App"] = "app";
    TwitterCard["Player"] = "player";
})(TwitterCard = exports.TwitterCard || (exports.TwitterCard = {}));
//# sourceMappingURL=types.js.map